"use strict";
let uidCount = 0;
function generateUID() {
  return uidCount++;
}

export { generateUID };
//# sourceMappingURL=generateUID.mjs.map
